import { defineComponent as _defineComponent } from 'vue'
import type { AssertByTypename } from '@/helpers/graphql-model-helper';
import type { GuideEntryFragment } from '@/features/editorial/graphql/queries/GetGuideArticles.query';

import AuthorBox from '@/features/editorial/components/AuthorBox.vue';
import PictureComp from '@/components/picture/PictureComp.vue';

import { getArticleSlug } from '@/features/editorial/helper';
import pictureCompHelper from '@/helpers/picture-comp-helper';
import { useEditorialTracking } from '@/features/editorial/tracking';
import { useLanguageStore } from '@/helpers/composables/useStores';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideItem',
  props: {
    item: null,
    index: { default: 0 },
    clamp: { default: 0 },
    isBadgeInline: { type: Boolean, default: true },
    showParagraph: { type: Boolean, default: true },
    variant: { default: 'standard' },
    h4Heading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { item: GuideEntryFragment, index: number, clamp: number, isBadgeInline: boolean, showParagraph: boolean, variant: 'featured' | 'standard' | 'list', h4Heading: boolean };



const { trackEditorial } = useEditorialTracking();

const { webLocale } = useLanguageStore();

const itemTitle = computed(() => {
	// the content is an HTML string so this slices out the <h1> tags
	if (props.item.content.title == null) return '';
	return props.item.content.title.replace(/<\/?[^>]+(>|$)/g, '');
});

const altText = computed(() => {
	return props.item?.content?.headerImage?.altText ?? itemTitle.value;
});

const headerImageURL = computed(() => {
	return props.item?.content?.headerImage?.url ?? '';
});

const mainImageEntityBackdrop = computed(() => {
	return props.item?.content?.mainImageEntityBackdrop?.backdropUrl ?? '';
});

const mainObject = computed(() => {
	type Node = GuideEntryFragment['mainObjects'][number]['node'];
	type MainObject = AssertByTypename<Node, 'GenericTitleList' | 'Movie' | 'Show' | 'Season'>;
	return props.item.mainObjects[0]?.node as MainObject;
});

const backdrop = computed(() => {
	if (!!headerImageURL.value) return headerImageURL.value;

	if (!!mainImageEntityBackdrop.value) return `${JW_CONFIG.IMAGESCALER_URL}${mainImageEntityBackdrop.value}`;

	if (!mainObject.value) return null;

	let backdropUrl: string | null = null;

	if (
		(mainObject.value.__typename === 'GenericTitleList' &&
			(mainObject.value.titles.edges ?? [])[0]?.nodeV2.content.backdrops[props.index]) ||
		(mainObject.value.__typename !== 'GenericTitleList' && mainObject.value.content.backdrops[props.index])
	) {
		backdropUrl =
			mainObject.value.__typename === 'GenericTitleList'
				? (mainObject.value.titles.edges ?? [])[0]?.nodeV2.content.backdrops[props.index]?.backdropUrl
				: mainObject.value.content.backdrops[props.index]?.backdropUrl;
	} else {
		backdropUrl =
			mainObject.value.__typename === 'GenericTitleList'
				? (mainObject.value.titles.edges ?? [])[0]?.nodeV2.content.backdrops[0]?.backdropUrl
				: mainObject.value.content.backdrops[0]?.backdropUrl;
	}

	if (!backdropUrl) return null;

	const profile = props.variant === 'featured' ? 'backdrop' : 'article_backdrop';
	return pictureCompHelper.getDefaultImageUrl(backdropUrl, profile, '', false);
});

// TRACKING
function trackClick(slug: string | null) {
	let label = '';
	if (slug) label = `https://guides.${JW_CONFIG.DOMAIN}/${webLocale.value}/${slug}`;
	const property = mainObject.value.__typename === 'GenericTitleList' ? 'editorial-list' : 'news';

	trackEditorial('clickGuideItemLink', {
		spec: { property, label, value: props.index },
	});
}

return { __sfc: true,props, trackEditorial, webLocale, itemTitle, altText, headerImageURL, mainImageEntityBackdrop, mainObject, backdrop, trackClick, AuthorBox, PictureComp, getArticleSlug }
}

})